// Sadece "/user-management" için yetki gereksinimi var.
// Diğer tüm path'ler için permission tanımlamaya gerek yok; undefined dönerse serbest geçiliyor.
import { ROLE } from "../constants";

const routePermissionsMap = {
  "/user-management": [ROLE.SystemAdministrator],
  "/accountant-management": [ROLE.SystemAdministrator, ROLE.Accountant],
  "/region-approver-matching": [ROLE.SystemAdministrator],
  "/expense-list?type=approved": [ROLE.SystemAdministrator, ROLE.Accountant],
  "/accounted-list": [ROLE.SystemAdministrator, ROLE.Accountant],
  "/expense-list?type=my_new_approve_expenses": [ROLE.SystemAdministrator, ROLE.Accountant],
  "/advance-list?type=approved": [ROLE.SystemAdministrator, ROLE.Accountant],
  "/advance-list?type=my_new_approve_advance  s": [ROLE.SystemAdministrator, ROLE.Accountant],
  "/advance-accounted-list": [ROLE.SystemAdministrator, ROLE.Accountant],
  "/motivation-budget-list": [ROLE.SystemAdministrator, ROLE.Accountant],
};

/**
 * Verilen path için permissions bilgisini döndürür.
 * @param {string} path
 * @returns {string[] | undefined}
 */
export function getRoutePermissions(path) {
  return routePermissionsMap[path] || undefined;
}
